module.exports = __webpack_public_path__ + "img/alarm.e200001f.gif";